import { api, signalr } from '@/f1/service'
import DatePicker from 'vue2-datepicker'
import moment from 'moment-timezone';
import agent from '../service'
import custom  from '@/f1/custom'
import _ from 'lodash'
import Chart from 'chart.js'
// import { LangStatus } from '@/f1/service/i18n';

const default_opt = () => ({
  perPage: 15, //limit,
  currentPage: 1, //
  totalRows: 0,
  adv : false,
  sk : '', sv : '', skt : '', opt : {}
})
const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.' , sortable: false, thStyle: 'width: 5%', },
    { key: 'is_alive', label: 'Status' , thStyle: 'width: 10%'},
    { key: 'mode', label: 'Recently Mode', thStyle: 'width: 10%' },
    { key: 'server', label: 'Server' }, // name[host]@ip_addr(version)
    { key: 'nickname', label: 'Nickname' },
    { key: 'domain', label: 'Domain', thStyle: 'width: 20%'},
    // { key: 'select', label: 'Detail' },
  ],
  KO: [
    { key: 'id', label: 'No.' , sortable: false, thStyle: 'width: 5%', },
    { key: 'is_alive', label: '상태' , thStyle: 'width: 10%'},
    { key: 'mode', label: '최근 적용 모드', thStyle: 'width: 10%' },
    { key: 'server', label: '서버' }, // name[host]@ip_addr(version)
    { key: 'nickname', label: '이름' },
    { key: 'domain', label: '도메인', thStyle: 'width: 20%'},
    // { key: 'select', label: '상세' },
  ]
}

export default {
  name: 'agentList',
  props: ['only_select', 'list_selected', 'agent_id', 'manage_id'],
  watch: {
    list_selected() {
      let id_list = this.list_selected.map(r => r.id)
      this.module_list.forEach(r => {
        r.check = id_list.indexOf(r.id) > -1 ? true : false
      })
      this.selected = id_list
      console.info("list_selected watch updated props data", this.selected.length)
    },
  },
  components : { DatePicker },
  data: () => ({
    is_show_dashboard : false,
    // like wsfinder
    modal_multi : false,
    custom,
    selected : [],
    module_list : [],
    // default
    // modify_nickname : '',
    // nickname_info : '',
    // nickname_modify_modal : false,
    // update_nickname : {},
    wc_copy_text : "copy",
    copy_text : "copy",
    show: false,
    so : default_opt(),
    modal_domain : false,
    modal_domain_info : {},
    del_info : {},
    modal_del : false,
    del_nickname : '',
    th : undefined,
    pong : { list : [], cnt : 12 },
    loading : false,
  }),
  computed: {
    domain_manage_fields: function () {
      return [
        { key: 'domain', thStyle: 'width: 10%', },
        { key: 'mode', thStyle: 'width: 5%', },
        { key: 'level', thStyle: 'width: 5%', },
      ]
    },
    fields() { return i18n_fields[localStorage['UWSS_LANG']]; },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() {
      return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage;
    }
  },
  methods: {
    usage_conevert_color(value) {
      // console.log('color', value)
      if(value >= 70) { return '#d00' }
      else if(value >= 30) { return '#fb0' }
      else { return '#2e7' }
    },
    create_chart(id="", data) {
      try {
        // console.log(id, document.getElementById(id), data)
        if(!id || !document.getElementById(id)) { console.log('no have id'); return '' }
        let d = { labels : _.map(data, (x, index) => index) }
        d.datasets = [{
          responsive: true,
          responsiveAnimationDuration: 1000,
          backgroundColor : this.usage_conevert_color(data[data.length -1]),
          borderColor: this.usage_conevert_color(data[data.length -1]),
          borderWidth: 2,
          data: data,
          // borderColor: 'rgb(75, 192, 192)',
          label : 'RAM',
          radius: 0,
        }]
        // console.log(d)
        let opt = {
          plugins: {
              legend: { display: false },
              // title: {
              //     display: true,
              //     text: 'Custom Chart Title',
              //     padding: {
              //         top: 10,
              //         bottom: 30
              //     }
              // }
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          // plugins: {

          // },
          scales: {
            xAxes: [{ id: 'x', display: false, title: { display: false, text: '' }, }],
            yAxes: [{ id: 'y', beginAtZero: true, display: false, title: { display: false, text: '' }, ticks: { beginAtZero: true, steps: 10, stepValue: 10, max: 100 } }],
          }
        }
        // console.log('draw', id)
        new Chart(document.getElementById(id), { type: 'line', data: d, options: opt })

      } catch (e) { console.log(e) }
    },
    mode_count(item, opt = { mode : 1 }) { return item.policy.domains && item.policy.domains.length ? _.filter(item.policy.domains, opt).length : 0 },
    // extra function
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.check) { return 'table-success' }
    },
    multi_click(record, index) {
      try{
        if(this.agent_id === undefined) {
          // 해당 값이 없으면 디테일로 변경
          return this.detail(record)
        }
        if(this.agent_id == record.id) { return this.$toastr.w("An agent from which to import settings") }
        this.multi_one(!record.check, { item: record }, false)
        console.debug("select", index)
      } catch (e) { this.$toastr.e("select one parser failed"); console.error(e) }
    },
    multi_one(value, row) {
      try {
        if(this.only_select != true) {
          return console.log("not selecting")
        }

        if(this.agent_id == row.item.id) { return this.$toastr.w("An agent from which to import settings") }
        else if(row.item.manage_id && row.item.manage_id > 0 && row.item.manage_id != this.manage_id) {
          return this.$toastr.w("Managed by multiplexing settings")
        }
        this.$parent.$emit("multi_one", { id: row.item.id, nickname: row.item.nickname, is_del: !value });
        if(!value) { this.selected = _.pull(this.selected, row.item.id) }
        else {
          this.selected.push(row.item.id)
        }
        this.selected = _.uniq(this.selected)
      } catch (e) { this.$toastr.e("select one parser failed"); console.error(e) }
    },
    multi_all() {
      try {
        this.module_list.forEach(r => {
          if(this.agent_id == r.id) { console.log("An agent from which to import settings"); return }
          else if(r.manage_id) { console.log("is already set policy"); return }
          else { r.check = true; this.selected.push(r.id) }
        })

        this.selected = _.uniq(this.selected)
        this.$parent.$emit("multi_all", _.uniq(this.module_list.map(r => { if(this.agent_id != r.id) { return { nickname: r.nickname, id: r.id } } })))
      } catch (e) { this.$toastr.e("select one parser failed"); console.error(e) }
    },
    multi_clear() {
      this.$parent.$emit("multi_clear", []); this.module_list.forEach(r => r.check = false)
      this.$refs._wc_agent_list ? this.$refs._wc_agent_list.clearSelected() : ''
      this.selected = []
    },
    refresh() {
      if(this.loading) { return }

      console.log('refresh', this.$refs._wc_agent_list ? 'DOM have table' : '-');
      this.$refs._wc_agent_list ? this.$refs._wc_agent_list.refresh() : this.load();
      if(!this.th) { this.th = setTimeout(() => this.refresh, 3000); }
    },
    reset() { this.so = default_opt(); this.$refs._wc_agent_list ? this.$refs._wc_agent_list.refresh() : ''},
    hideList(e) { this.show = !e; console.log('agent.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide') },
    Download(){ this.$router.replace(`/downloads/`); },
    async ping(){
      if(this.th) { clearTimeout(this.th); }
      if(!(this.module_list && this.module_list.length)) { return }

      (this.module_list || []).forEach((r, index) => {
        agent.Cmd("ping", r.id)
        if(index == 0 && this.is_show_dashboard) { agent.Cmd("status", r.id) }
      });
      this.th = setTimeout(this.ping, 3000)
    },
    remove() {
      this.del_nickname = this.del_nickname.trim()
      if(this.del_info.nickname != this.del_nickname) { return this.$toastr.e('Invalid server name entered');  }
      api.webcastle.WebCastle_Call('agent', 'delete', { id : this.del_info.id }).then(() => this.refresh()).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText) );
      this.del_info = {};
      this.del_nickname = '';
      this.modal_del = true;
    },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      if(this.loading) {
        return this.loading = false
      }
      this.loading = true
      let so = {
        ok : ctx.sortBy,
        // od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {},
        target : 'agent', cmd : 'list'
      }
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, target : so.target, cmd : so.cmd, body: { and: [{name : 'is_del', value:false, op: '='}], or: [], sort: [{name : 'id', op : 'desc'}] } }
      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search
      if(so.sk && so.sv) {
        const value = so.sv
        for(let key of so.sk.split(',')) {
          search.body.or.push({name: key, value: `%${value}%`, op: 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'mode' : search.body.and.push({name: 'mode', value: Number(value) , op: '=' }); break;
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          case 'last_visit_sd' : search.body.and.push({name: 'last_visit', value: moment(value).valueOf(), op: '>=' }); break;
          case 'last_visit_ed' : search.body.and.push({name: 'last_visit', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: `%${value}%`, op: 'like' }); break;
        }
      }
      try{
        let rs = await api.webcastle.WebCastle(search);
        if(rs.error) { return this.$toastr.e("load failed") }
        this.so.totalRows = rs.total;
        this.module_list =  _.map(rs.body, r => { try { r.status_ram = []; r.status_cpu = []; r.check = this.selected.indexOf(r.id) > -1; r.policy = JSON.parse(r.policy); } catch (e) { console.log("policy parser issue") } return r });
        this.show = this.so.totalRows > 0 ? true : false;
        this.ping()
        // setTimeout(() => this.ping, 3000);
        this.$parent.$emit('count', this.so.totalRows)
        this.$parent.$emit('agent_list', this.module_list)

        // 초기 선택을 위함
        if(this.list_selected) {
          let id_list = this.list_selected.map(r => r.id)
          this.module_list.forEach(r => {
            r.check = id_list.indexOf(r.id) > -1 ? true : false
          })
          this.selected = id_list
          console.info("list_selected watch updated props data", this.selected.length)
        }

        this.loading = false
        return this.module_list;
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
    detail: function(item) {
      this.signalr && this.signalr.off('webcastle');
      this.$router.push(`modules/v2/${item.id}`);
    },
    res(m) {

      try {
        if(m.cmd == 'pong') {
          _.indexOf(this.pong.list, m.agent_id) == -1 ? this.pong.list.push(m.agent_id) : ''
        } else if(m.cmd == 'status') {
          let index = _.findIndex(this.module_list, x => x.id == m.agent_id)
          let status = {
            usage_cpu :  m.body.system_cpu_info && typeof m.body.system_cpu_info == typeof '' ? JSON.parse(m.body.system_cpu_info).usage : m.body.system_cpu_info.usage,
            usage_ram :  m.body.system_memory_info && typeof m.body.system_memory_info == typeof '' ? Number(JSON.parse(m.body.system_memory_info).usedPercent.toFixed(0)) : Number(m.body.system_memory_info.usedPercent.toFixed(0)),
          }

          this.module_list[index].status_ram.push(status.usage_ram)
          if(this.module_list[index].status_ram.length > 12) { this.module_list[index].status_ram = this.module_list[index].status_ram.splice(1) }
          this.module_list[index].status_cpu.push(status.usage_cpu)
          if(this.module_list[index].status_cpu.length > 12) { this.module_list[index].status_cpu = this.module_list[index].status_cpu.splice(1) }

          this.create_chart(`ram_${m.agent_id}`, JSON.parse(JSON.stringify(this.module_list[index].status_ram)))
          this.create_chart(`cpu_${m.agent_id}`, JSON.parse(JSON.stringify(this.module_list[index].status_cpu)))
        }
      } catch (e) {
        console.log(e)
      }
    },
  },
  created: function() {
    // if(this.only_select != true) { i18n_fields[localStorage['UWSS_LANG']].push({ key: 'select', label: 'More' }) }
    console.log('modules.list.vue', 'created');
  },
  destroyed: function() {
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    signalr.off('webcastle', this.res);
    console.info('modules.list.vue', 'destroyed');
  },
  mounted: function() {
    console.info('modules.list.vue', 'mounted');
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    signalr.on('webcastle', this.res)
  },
}
